import { jwtDecode } from '@/helpers/jwt.js'
import { organizationService, userService } from '@/services'

let initialState = {
  organizations: [
    {
      id: null, // number
      name: null, // string
      isAdmin: null // boolean
    }
  ],
  globalSelectedOrganization: {
    id: null, // number
    name: null, // string
    isAdmin: null // boolean
  },
  administrationTabSelectedOrganization: {
    id: null, // number
    name: null, // string
    isAdmin: null // boolean
  },
  masterData: {
    isValid: false,
    isLoading: false,
  }
}

export default {
  state: () => initialState,
  mutations: {
    SET_ORGANIZATIONS(state, organizations) {
      state.organizations = organizations
    },
    SET_SELECTED_ORGANIZATION(state, organization) {
      state.globalSelectedOrganization = organization
    },
    SET_ADMINISTRATION_TAB_SELECTED_ORGANIZATION(state, organization) {
      state.administrationTabSelectedOrganization = organization
    },
    ADD_ORGANIZATION(state, organization) {
      state.organizations.push(organization)
    },
    RESET_ORGANIZATIONS(state) {
      state.globalSelectedOrganization = initialState.globalSelectedOrganization
      state.organizations = initialState.organizations
    },
    SET_MASTER_DATA(state, payload) {
      state.masterData = payload
    },
    SET_MASTER_DATA_VALIDITY(state, payload) {
      // if (!state.masterData) {
      //   state.masterData = {}
      // }
      state.masterData.isValid = payload
    },
    SET_MASTER_DATA_LOADING(state, payload) {
      state.masterData.isLoading = payload
    }
  },
  actions: {
    async getMyOrganizations({ commit }) {
      try {
        const response = await organizationService.getMyOrganizations()
        commit('SET_ORGANIZATIONS', Array.isArray(response?.data) ? response?.data : [])
      } catch (error) {
        console.error('Error when loading organizations:', error)
        commit('SET_ORGANIZATIONS', [])
      }
    },
    async getOrganizationInformationById({ commit }, { organizationId, setSelectedOrganization = true }) {
      return new Promise(async (resolve, reject) => {
        await organizationService
          .getOrganizationById(organizationId)
          .then(response => {
            if(setSelectedOrganization) {
              commit('SET_SELECTED_ORGANIZATION', response?.data)
            }
            resolve(response?.data)
          })
          .catch(() => {
            reject()
          })
      })
    },
    async createOrganization({ dispatch }, payload) {
      return new Promise(async (resolve, reject) => {
        await organizationService
          .create(payload)
          .then(() => {
            dispatch('refreshToken') // update entry.state.jwt
            resolve(true)
          })
          .catch(() => {
            reject()
          })
      })
    },
    async renameOrganization({ dispatch }, organization) {
      return new Promise(async (resolve, reject) => {
        await organizationService
          .rename({
            id: organization.id,
            name: organization.name
          })
          .then(() => {
            dispatch('refreshToken')
            resolve(true)
          })
          .catch(() => {
            reject()
          })
      })
    },
    refreshToken({ dispatch }) {
      return new Promise(async (resolve, reject) => {
        await userService
          .refreshToken()
          .then(response => {
            response.jwt && dispatch('setOrganizationByLoginResponse', response) // update organizationData
            resolve(true)
          })
          .catch(() => {
            reject()
          })
      })
    },
    setOrganizationByLoginResponse({ commit }, loginResponse) {
      if (loginResponse.jwt) {
        const organizations = jwtDecode(loginResponse?.jwt)?.organizations || []
        const globalSelectedOrganization = jwtDecode(loginResponse.jwt)?.globalSelectedOrganization || null
        commit('SET_ORGANIZATIONS', [])
        if (organizations.length > 0) {
          organizations.sort((a, b) =>
            a?.name?.localeCompare(b.name)
          )
          organizations.forEach(organization => {
            commit('ADD_ORGANIZATION', organization)
          });
        }
        if (globalSelectedOrganization) {
          commit('SET_SELECTED_ORGANIZATION', globalSelectedOrganization)
        } else {
          commit('SET_SELECTED_ORGANIZATION', organizations[0])
        }
      }
    },
    async setSelectedOrganization({ commit, dispatch }, organization) {
      const newToken = await organizationService.changeSelectedOrganization(organization)
      if(newToken?.data?.jwt) {
        dispatch('setPermissions', newToken?.data?.jwt, { root: true })
        dispatch('setToken', newToken?.data?.jwt, { root: true })
      }
      commit('SET_SELECTED_ORGANIZATION', organization)
    },
    async setAdministrationTabSelectedOrganization({ commit }, organization) {
      if (organization) {
        commit('SET_ADMINISTRATION_TAB_SELECTED_ORGANIZATION', organization)
      } else {
        commit('SET_ADMINISTRATION_TAB_SELECTED_ORGANIZATION', initialState.administrationTabSelectedOrganization)
      }
    },
    resetOrganizations({ commit }) {
      commit('RESET_ORGANIZATIONS')
    },
    refreshEmployeeList() {
      return true
    },
    refreshInboxesList() {
      return true
    },
    setMasterData(){
      //commit('SET_MASTER_DATA')
      return true
    },
    setMasterDataValidity({commit}, payload){
      commit('SET_MASTER_DATA_VALIDITY', payload)
    },
    setMasterDataLoading({commit}, payload){
      commit('SET_MASTER_DATA_LOADING', payload)
    }
  },
  getters: {
    masterData: state => {
      return state.masterData
    },
    isMasterDataValid: state => {
      return state.masterData?.isValid
    },
    isMasterDataLoading: state => {
      return state.masterData?.isLoading
    },
    hasOrganizations: state => {
      return state.organizations.length > 0
    },
    organizations: state => {
      return state.organizations
    },
    flatAndSortedOrganizations: state => {
      return [...state.organizations]
      .map(org => ({
        id: org.id,
        name: org.name,
        isAdmin: org.isAdmin
      }))
      .sort((a, b) => (a.name || '').localeCompare(b.name || ''))
    },
    treeviewOrganizations: state => {
      if (!Array.isArray(state.organizations)) return []

      const sorted = [...state.organizations].sort((a, b) =>
        (a.name || '').localeCompare(b.name || '')
      )

      const orgMap = new Map()

      sorted.forEach(org => {
        orgMap.set(org.id, { ...org, children: [] })
      })

      const rootNodes = []

      sorted.forEach(org => {
        const current = orgMap.get(org.id)

        if (org.parent && org.parent.id && orgMap.has(org.parent.id)) {
          orgMap.get(org.parent.id).children.push(current)
        } else {
          rootNodes.push(current)
        }
      })

      return rootNodes
    },
    isAdminInAnyOrganization: state => {
      return Array.isArray(state.organizations) && state.organizations.some(org => org?.isAdmin)
    },
    organizationsWithAdminPermissions: state => {
      if (
        typeof state.organizations === 'undefined' ||
        state.organizations === null
      ) {
        return []
      }
      return state.organizations.filter(org => org.isAdmin)
    },
    selectedOrganization: state => {
      if (
        state.globalSelectedOrganization?.id === null &&
        state.organizations.length > 0
      ) {
        return state.organizations[0]
      }
      return state.globalSelectedOrganization
    },
    administrationTabSelectedOrganization: state => {
      if (
        state.administrationTabSelectedOrganization.id === null &&
        state.organizations.length > 0
      ) {
        return state.organizations[0]
      }
      return state.administrationTabSelectedOrganization
    }
  }
}
